import React from 'react';
import styled from '@emotion/styled';
import { Item as ChequeItem } from '@baemingo/table-events/dist/types';
import { useSelector } from '~Hooks';
import useOrderedChequeItems, { OrderedChequeItem } from '~Hooks/useOrderedChequeItems';
import { chequeItemToLocalItem } from '~Utils/chequeItems';
import ItemRow from '../Item';
import OfferItemWrapper from '../OfferItemWrapper';

/** Dimmed and non-interactive, the rows are only a reference of what is already on the cheque */
const Wrapper = styled.div`
  opacity: 0.4;
  pointer-events: none;
`;

interface Props {
  items: ChequeItem[];
}

/**
 * Renders the items that already are on the cheque (TSR) below the cart items,
 * in the same order as the cheque view (Tables Articles).
 */
const ChequeItemRows = ({ items }: Props) => {
  const courseTypes = useSelector((state) => state.courseTypes);
  const ordered = useOrderedChequeItems(items);

  if (items.length === 0) {
    return null;
  }

  const renderRow = (item: OrderedChequeItem, hidePrice?: boolean) => {
    const localItem = chequeItemToLocalItem(item, courseTypes);

    return (
      <ItemRow
        key={item.id}
        item={{
          ...localItem,
          /** Rounded fraction from localItem, the row shows it as qty when not compressed */
          entry: { amount: item.amount, discount: item.discount, fraction: localItem.fraction },
        }}
        changeCourseType={() => {}}
        hidePrice={hidePrice}
      />
    );
  };

  return (
    <Wrapper data-test="cart-cheque-items">
      {ordered.unmatched.map((item) => renderRow(item))}
      {ordered.matches.map((offerMatch, index) => (
        <OfferItemWrapper
          key={`offer-${index}`}
          offerId={offerMatch.offerId}
          oldPrice={offerMatch.oldPrice}
          newPrice={offerMatch.newPrice}>
          {offerMatch.items.map((item) => renderRow(item, true))}
        </OfferItemWrapper>
      ))}
    </Wrapper>
  );
};

export default React.memo(ChequeItemRows);
